export const phones = {
  "Afghanistan-00-000-0000": {
    "name": "Afghanistan",
    "code": "+93",
    "iso": "AF",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/af.svg",
    "mask": "00-000-0000",
    "value": "Afghanistan-00-000-0000",
    "label": "Afghanistan (AF)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Afghanistan (AF)"
  },
  "Aland Islands-(000)000-00-00": {
    "name": "Aland Islands",
    "code": "+358",
    "iso": "AX",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ax.svg",
    "mask": "(000)000-00-00",
    "value": "Aland Islands-(000)000-00-00",
    "label": "Aland Islands (AX)",
    "maskPlaceholder": "(000)000-00-00",
    "applyMask": "(999)999-99-99",
    "description": "Aland Islands (AX)"
  },
  "Albania-(000)000-000": {
    "name": "Albania",
    "code": "+355",
    "iso": "AL",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/al.svg",
    "mask": "(000)000-000",
    "value": "Albania-(000)000-000",
    "label": "Albania (AL)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Albania (AL)"
  },
  "Algeria-00-000-0000": {
    "name": "Algeria",
    "code": "+213",
    "iso": "DZ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/dz.svg",
    "mask": "00-000-0000",
    "value": "Algeria-00-000-0000",
    "label": "Algeria (DZ)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Algeria (DZ)"
  },
  "American Samoa-(684)000-0000": {
    "name": "American Samoa",
    "code": "+1",
    "iso": "AS",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/as.svg",
    "mask": "(684)000-0000",
    "value": "American Samoa-(684)000-0000",
    "label": "American Samoa (AS)",
    "maskPlaceholder": "(684)000-0000",
    "applyMask": "(684)999-9999",
    "description": "American Samoa (AS)"
  },
  "Andorra-000-000": {
    "name": "Andorra",
    "code": "+376",
    "iso": "AD",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ad.svg",
    "mask": "000-000",
    "value": "Andorra-000-000",
    "label": "Andorra (AD)",
    "maskPlaceholder": "000-000",
    "applyMask": "999-999",
    "description": "Andorra (AD)"
  },
  "Angola-(000)000-000": {
    "name": "Angola",
    "code": "+244",
    "iso": "AO",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ao.svg",
    "mask": "(000)000-000",
    "value": "Angola-(000)000-000",
    "label": "Angola (AO)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Angola (AO)"
  },
  "Anguilla-(264)000-0000": {
    "name": "Anguilla",
    "code": "+1",
    "iso": "AI",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ai.svg",
    "mask": "(264)000-0000",
    "value": "Anguilla-(264)000-0000",
    "label": "Anguilla (AI)",
    "maskPlaceholder": "(264)000-0000",
    "applyMask": "(264)999-9999",
    "description": "Anguilla (AI)"
  },
  "Antarctica-100-000": {
    "name": "Antarctica",
    "code": "+672",
    "iso": "AQ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/aq.svg",
    "mask": "100-000",
    "value": "Antarctica-100-000",
    "label": "Antarctica (AQ)",
    "maskPlaceholder": "100-000",
    "applyMask": "199-999",
    "description": "Antarctica (AQ)"
  },
  "Antigua and Barbuda-(268)000-0000": {
    "name": "Antigua and Barbuda",
    "code": "+1",
    "iso": "AG",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ag.svg",
    "mask": "(268)000-0000",
    "value": "Antigua and Barbuda-(268)000-0000",
    "label": "Antigua and Barbuda (AG)",
    "maskPlaceholder": "(268)000-0000",
    "applyMask": "(268)999-9999",
    "description": "Antigua and Barbuda (AG)"
  },
  "Argentina-(000)000-0000": {
    "name": "Argentina",
    "code": "+54",
    "iso": "AR",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ar.svg",
    "mask": "(000)000-0000",
    "value": "Argentina-(000)000-0000",
    "label": "Argentina (AR)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "Argentina (AR)"
  },
  "Armenia-00-000-000": {
    "name": "Armenia",
    "code": "+374",
    "iso": "AM",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/am.svg",
    "mask": "00-000-000",
    "value": "Armenia-00-000-000",
    "label": "Armenia (AM)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Armenia (AM)"
  },
  "Aruba-000-0000": {
    "name": "Aruba",
    "code": "+297",
    "iso": "AW",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/aw.svg",
    "mask": "000-0000",
    "value": "Aruba-000-0000",
    "label": "Aruba (AW)",
    "maskPlaceholder": "000-0000",
    "applyMask": "999-9999",
    "description": "Aruba (AW)"
  },
  "Ascension Island-0000": {
    "name": "Ascension Island",
    "code": "+247",
    "iso": "AC",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sh.svg",
    "mask": "0000",
    "value": "Ascension Island-0000",
    "label": "Ascension Island (AC)",
    "maskPlaceholder": "0000",
    "applyMask": "9999",
    "description": "Ascension Island (AC)"
  },
  "Australia-0-0000-0000": {
    "name": "Australia",
    "code": "+61",
    "iso": "AU",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/au.svg",
    "mask": "0-0000-0000",
    "value": "Australia-0-0000-0000",
    "label": "Australia (AU)",
    "maskPlaceholder": "0-0000-0000",
    "applyMask": "9-9999-9999",
    "description": "Australia (AU)"
  },
  "Austria-(000)000-0000": {
    "name": "Austria",
    "code": "+43",
    "iso": "AT",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/at.svg",
    "mask": "(000)000-0000",
    "value": "Austria-(000)000-0000",
    "label": "Austria (AT)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "Austria (AT)"
  },
  "Azerbaijan-00-000-00-00": {
    "name": "Azerbaijan",
    "code": "+994",
    "iso": "AZ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/az.svg",
    "mask": "00-000-00-00",
    "value": "Azerbaijan-00-000-00-00",
    "label": "Azerbaijan (AZ)",
    "maskPlaceholder": "00-000-00-00",
    "applyMask": "99-999-99-99",
    "description": "Azerbaijan (AZ)"
  },
  "Bahamas-(242)000-0000": {
    "name": "Bahamas",
    "code": "+1",
    "iso": "BS",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/bs.svg",
    "mask": "(242)000-0000",
    "value": "Bahamas-(242)000-0000",
    "label": "Bahamas (BS)",
    "maskPlaceholder": "(242)000-0000",
    "applyMask": "(242)999-9999",
    "description": "Bahamas (BS)"
  },
  "Bahrain-0000-0000": {
    "name": "Bahrain",
    "code": "+973",
    "iso": "BH",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/bh.svg",
    "mask": "0000-0000",
    "value": "Bahrain-0000-0000",
    "label": "Bahrain (BH)",
    "maskPlaceholder": "0000-0000",
    "applyMask": "9999-9999",
    "description": "Bahrain (BH)"
  },
  "Bangladesh-1000-000000": {
    "name": "Bangladesh",
    "code": "+880",
    "iso": "BD",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/bd.svg",
    "mask": "1000-000000",
    "value": "Bangladesh-1000-000000",
    "label": "Bangladesh (BD)",
    "maskPlaceholder": "1000-000000",
    "applyMask": "1999-999999",
    "description": "Bangladesh (BD)"
  },
  "Barbados-(246)000-0000": {
    "name": "Barbados",
    "code": "+1",
    "iso": "BB",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/bb.svg",
    "mask": "(246)000-0000",
    "value": "Barbados-(246)000-0000",
    "label": "Barbados (BB)",
    "maskPlaceholder": "(246)000-0000",
    "applyMask": "(246)999-9999",
    "description": "Barbados (BB)"
  },
  "Belarus-(00)000-00-00": {
    "name": "Belarus",
    "code": "+375",
    "iso": "BY",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/by.svg",
    "mask": "(00)000-00-00",
    "value": "Belarus-(00)000-00-00",
    "label": "Belarus (BY)",
    "maskPlaceholder": "(00)000-00-00",
    "applyMask": "(99)999-99-99",
    "description": "Belarus (BY)"
  },
  "Belgium-(000)000-000": {
    "name": "Belgium",
    "code": "+32",
    "iso": "BE",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/be.svg",
    "mask": "(000)000-000",
    "value": "Belgium-(000)000-000",
    "label": "Belgium (BE)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Belgium (BE)"
  },
  "Belize-000-0000": {
    "name": "Belize",
    "code": "+501",
    "iso": "BZ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/bz.svg",
    "mask": "000-0000",
    "value": "Belize-000-0000",
    "label": "Belize (BZ)",
    "maskPlaceholder": "000-0000",
    "applyMask": "999-9999",
    "description": "Belize (BZ)"
  },
  "Benin-00-00-0000": {
    "name": "Benin",
    "code": "+229",
    "iso": "BJ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/bj.svg",
    "mask": "00-00-0000",
    "value": "Benin-00-00-0000",
    "label": "Benin (BJ)",
    "maskPlaceholder": "00-00-0000",
    "applyMask": "99-99-9999",
    "description": "Benin (BJ)"
  },
  "Bermuda-(441)000-0000": {
    "name": "Bermuda",
    "code": "+1",
    "iso": "BM",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/bm.svg",
    "mask": "(441)000-0000",
    "value": "Bermuda-(441)000-0000",
    "label": "Bermuda (BM)",
    "maskPlaceholder": "(441)000-0000",
    "applyMask": "(441)999-9999",
    "description": "Bermuda (BM)"
  },
  "Bhutan-0-000-000": {
    "name": "Bhutan",
    "code": "+975",
    "iso": "BT",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/bt.svg",
    "mask": "0-000-000",
    "value": "Bhutan-0-000-000",
    "label": "Bhutan (BT)",
    "maskPlaceholder": "0-000-000",
    "applyMask": "9-999-999",
    "description": "Bhutan (BT)"
  },
  "Bolivia-0-000-0000": {
    "name": "Bolivia",
    "code": "+591",
    "iso": "BO",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/bo.svg",
    "mask": "0-000-0000",
    "value": "Bolivia-0-000-0000",
    "label": "Bolivia (BO)",
    "maskPlaceholder": "0-000-0000",
    "applyMask": "9-999-9999",
    "description": "Bolivia (BO)"
  },
  "Bosnia and Herzegovina-00-00000": {
    "name": "Bosnia and Herzegovina",
    "code": "+387",
    "iso": "BA",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ba.svg",
    "mask": "00-00000",
    "value": "Bosnia and Herzegovina-00-00000",
    "label": "Bosnia and Herzegovina (BA)",
    "maskPlaceholder": "00-00000",
    "applyMask": "99-99999",
    "description": "Bosnia and Herzegovina (BA)"
  },
  "Botswana-00-000-000": {
    "name": "Botswana",
    "code": "+267",
    "iso": "BW",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/bw.svg",
    "mask": "00-000-000",
    "value": "Botswana-00-000-000",
    "label": "Botswana (BW)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Botswana (BW)"
  },
  "Brazil-(00)00000-0000": {
    "name": "Brazil",
    "code": "+55",
    "iso": "BR",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/br.svg",
    "mask": "(00)00000-0000",
    "value": "Brazil-(00)00000-0000",
    "label": "Brazil (BR)",
    "maskPlaceholder": "(00)00000-0000",
    "applyMask": "(99)99999-9999",
    "description": "Brazil (BR)"
  },
  "British Indian Ocean Territory-000-0000": {
    "name": "British Indian Ocean Territory",
    "code": "+246",
    "iso": "IO",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/io.svg",
    "mask": "000-0000",
    "value": "British Indian Ocean Territory-000-0000",
    "label": "British Indian Ocean Territory (IO)",
    "maskPlaceholder": "000-0000",
    "applyMask": "999-9999",
    "description": "British Indian Ocean Territory (IO)"
  },
  "Brunei Darussalam-000-0000": {
    "name": "Brunei Darussalam",
    "code": "+673",
    "iso": "BN",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/bn.svg",
    "mask": "000-0000",
    "value": "Brunei Darussalam-000-0000",
    "label": "Brunei Darussalam (BN)",
    "maskPlaceholder": "000-0000",
    "applyMask": "999-9999",
    "description": "Brunei Darussalam (BN)"
  },
  "Bulgaria-(000)000-000": {
    "name": "Bulgaria",
    "code": "+359",
    "iso": "BG",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/bg.svg",
    "mask": "(000)000-000",
    "value": "Bulgaria-(000)000-000",
    "label": "Bulgaria (BG)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Bulgaria (BG)"
  },
  "Burkina Faso-00-00-0000": {
    "name": "Burkina Faso",
    "code": "+226",
    "iso": "BF",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/bf.svg",
    "mask": "00-00-0000",
    "value": "Burkina Faso-00-00-0000",
    "label": "Burkina Faso (BF)",
    "maskPlaceholder": "00-00-0000",
    "applyMask": "99-99-9999",
    "description": "Burkina Faso (BF)"
  },
  "Burundi-00-00-0000": {
    "name": "Burundi",
    "code": "+257",
    "iso": "BI",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/bi.svg",
    "mask": "00-00-0000",
    "value": "Burundi-00-00-0000",
    "label": "Burundi (BI)",
    "maskPlaceholder": "00-00-0000",
    "applyMask": "99-99-9999",
    "description": "Burundi (BI)"
  },
  "Cambodia-00-000-000": {
    "name": "Cambodia",
    "code": "+855",
    "iso": "KH",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/kh.svg",
    "mask": "00-000-000",
    "value": "Cambodia-00-000-000",
    "label": "Cambodia (KH)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Cambodia (KH)"
  },
  "Cameroon-0000-0000": {
    "name": "Cameroon",
    "code": "+237",
    "iso": "CM",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/cm.svg",
    "mask": "0000-0000",
    "value": "Cameroon-0000-0000",
    "label": "Cameroon (CM)",
    "maskPlaceholder": "0000-0000",
    "applyMask": "9999-9999",
    "description": "Cameroon (CM)"
  },
  "Canada-(000)000-0000": {
    "name": "Canada",
    "code": "+1",
    "iso": "CA",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ca.svg",
    "mask": "(000)000-0000",
    "value": "Canada-(000)000-0000",
    "label": "Canada (CA)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "Canada (CA)"
  },
  "Cape Verde-(000)00-00": {
    "name": "Cape Verde",
    "code": "+238",
    "iso": "CV",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/cv.svg",
    "mask": "(000)00-00",
    "value": "Cape Verde-(000)00-00",
    "label": "Cape Verde (CV)",
    "maskPlaceholder": "(000)00-00",
    "applyMask": "(999)99-99",
    "description": "Cape Verde (CV)"
  },
  "Cayman Islands-(345)000-0000": {
    "name": "Cayman Islands",
    "code": "+1",
    "iso": "KY",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ky.svg",
    "mask": "(345)000-0000",
    "value": "Cayman Islands-(345)000-0000",
    "label": "Cayman Islands (KY)",
    "maskPlaceholder": "(345)000-0000",
    "applyMask": "(345)999-9999",
    "description": "Cayman Islands (KY)"
  },
  "Central African Republic-00-00-0000": {
    "name": "Central African Republic",
    "code": "+236",
    "iso": "CF",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/cf.svg",
    "mask": "00-00-0000",
    "value": "Central African Republic-00-00-0000",
    "label": "Central African Republic (CF)",
    "maskPlaceholder": "00-00-0000",
    "applyMask": "99-99-9999",
    "description": "Central African Republic (CF)"
  },
  "Chad-00-00-00-00": {
    "name": "Chad",
    "code": "+235",
    "iso": "TD",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/td.svg",
    "mask": "00-00-00-00",
    "value": "Chad-00-00-00-00",
    "label": "Chad (TD)",
    "maskPlaceholder": "00-00-00-00",
    "applyMask": "99-99-99-99",
    "description": "Chad (TD)"
  },
  "Chile-0-0000-0000": {
    "name": "Chile",
    "code": "+56",
    "iso": "CL",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/cl.svg",
    "mask": "0-0000-0000",
    "value": "Chile-0-0000-0000",
    "label": "Chile (CL)",
    "maskPlaceholder": "0-0000-0000",
    "applyMask": "9-9999-9999",
    "description": "Chile (CL)"
  },
  "China-00-00000-00000": {
    "name": "China",
    "code": "+86",
    "iso": "CN",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/cn.svg",
    "mask": "00-00000-00000",
    "value": "China-00-00000-00000",
    "label": "China (CN)",
    "maskPlaceholder": "00-00000-00000",
    "applyMask": "99-99999-99999",
    "description": "China (CN)"
  },
  "Christmas Island-0-0000-0000": {
    "name": "Christmas Island",
    "code": "+61",
    "iso": "CX",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/cx.svg",
    "mask": "0-0000-0000",
    "value": "Christmas Island-0-0000-0000",
    "label": "Christmas Island (CX)",
    "maskPlaceholder": "0-0000-0000",
    "applyMask": "9-9999-9999",
    "description": "Christmas Island (CX)"
  },
  "Cocos (Keeling) Islands-0-0000-0000": {
    "name": "Cocos (Keeling) Islands",
    "code": "+61",
    "iso": "CC",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/cc.svg",
    "mask": "0-0000-0000",
    "value": "Cocos (Keeling) Islands-0-0000-0000",
    "label": "Cocos (Keeling) Islands (CC)",
    "maskPlaceholder": "0-0000-0000",
    "applyMask": "9-9999-9999",
    "description": "Cocos (Keeling) Islands (CC)"
  },
  "Colombia-(000)000-0000": {
    "name": "Colombia",
    "code": "+57",
    "iso": "CO",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/co.svg",
    "mask": "(000)000-0000",
    "value": "Colombia-(000)000-0000",
    "label": "Colombia (CO)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "Colombia (CO)"
  },
  "Comoros-00-00000": {
    "name": "Comoros",
    "code": "+269",
    "iso": "KM",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/km.svg",
    "mask": "00-00000",
    "value": "Comoros-00-00000",
    "label": "Comoros (KM)",
    "maskPlaceholder": "00-00000",
    "applyMask": "99-99999",
    "description": "Comoros (KM)"
  },
  "Congo-00-00000": {
    "name": "Congo",
    "code": "+242",
    "iso": "CG",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/cg.svg",
    "mask": "00-00000",
    "value": "Congo-00-00000",
    "label": "Congo (CG)",
    "maskPlaceholder": "00-00000",
    "applyMask": "99-99999",
    "description": "Congo (CG)"
  },
  "Cook Islands-00-000": {
    "name": "Cook Islands",
    "code": "+682",
    "iso": "CK",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ck.svg",
    "mask": "00-000",
    "value": "Cook Islands-00-000",
    "label": "Cook Islands (CK)",
    "maskPlaceholder": "00-000",
    "applyMask": "99-999",
    "description": "Cook Islands (CK)"
  },
  "Costa Rica-0000-0000": {
    "name": "Costa Rica",
    "code": "+506",
    "iso": "CR",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/cr.svg",
    "mask": "0000-0000",
    "value": "Costa Rica-0000-0000",
    "label": "Costa Rica (CR)",
    "maskPlaceholder": "0000-0000",
    "applyMask": "9999-9999",
    "description": "Costa Rica (CR)"
  },
  "Croatia-00-000-000": {
    "name": "Croatia",
    "code": "+385",
    "iso": "HR",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/hr.svg",
    "mask": "00-000-000",
    "value": "Croatia-00-000-000",
    "label": "Croatia (HR)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Croatia (HR)"
  },
  "Cuba-0-000-0000": {
    "name": "Cuba",
    "code": "+53",
    "iso": "CU",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/cu.svg",
    "mask": "0-000-0000",
    "value": "Cuba-0-000-0000",
    "label": "Cuba (CU)",
    "maskPlaceholder": "0-000-0000",
    "applyMask": "9-999-9999",
    "description": "Cuba (CU)"
  },
  "Cyprus-00-000-000": {
    "name": "Cyprus",
    "code": "+357",
    "iso": "CY",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/cy.svg",
    "mask": "00-000-000",
    "value": "Cyprus-00-000-000",
    "label": "Cyprus (CY)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Cyprus (CY)"
  },
  "Czech Republic-(000)000-000": {
    "name": "Czech Republic",
    "code": "+420",
    "iso": "CZ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/cz.svg",
    "mask": "(000)000-000",
    "value": "Czech Republic-(000)000-000",
    "label": "Czech Republic (CZ)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Czech Republic (CZ)"
  },
  "Democratic Republic of the Congo-(000)000-000": {
    "name": "Democratic Republic of the Congo",
    "code": "+243",
    "iso": "CD",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/cd.svg",
    "mask": "(000)000-000",
    "value": "Democratic Republic of the Congo-(000)000-000",
    "label": "Democratic Republic of the Congo (CD)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Democratic Republic of the Congo (CD)"
  },
  "Denmark-00-00-00-00": {
    "name": "Denmark",
    "code": "+45",
    "iso": "DK",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/dk.svg",
    "mask": "00-00-00-00",
    "value": "Denmark-00-00-00-00",
    "label": "Denmark (DK)",
    "maskPlaceholder": "00-00-00-00",
    "applyMask": "99-99-99-99",
    "description": "Denmark (DK)"
  },
  "Djibouti-00-00-00-00": {
    "name": "Djibouti",
    "code": "+253",
    "iso": "DJ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/dj.svg",
    "mask": "00-00-00-00",
    "value": "Djibouti-00-00-00-00",
    "label": "Djibouti (DJ)",
    "maskPlaceholder": "00-00-00-00",
    "applyMask": "99-99-99-99",
    "description": "Djibouti (DJ)"
  },
  "Dominica-(767)000-0000": {
    "name": "Dominica",
    "code": "+1",
    "iso": "DM",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/dm.svg",
    "mask": "(767)000-0000",
    "value": "Dominica-(767)000-0000",
    "label": "Dominica (DM)",
    "maskPlaceholder": "(767)000-0000",
    "applyMask": "(767)999-9999",
    "description": "Dominica (DM)"
  },
  "Dominican Republic-(849)000-0000": {
    "name": "Dominican Republic",
    "code": "+1",
    "iso": "DO",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/do.svg",
    "mask": "(849)000-0000",
    "value": "Dominican Republic-(849)000-0000",
    "label": "Dominican Republic (DO)",
    "maskPlaceholder": "(849)000-0000",
    "applyMask": "(849)999-9999",
    "description": "Dominican Republic (DO)"
  },
  "Ecuador-00-000-0000": {
    "name": "Ecuador",
    "code": "+593",
    "iso": "EC",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ec.svg",
    "mask": "00-000-0000",
    "value": "Ecuador-00-000-0000",
    "label": "Ecuador (EC)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Ecuador (EC)"
  },
  "Egypt-(000)000-0000": {
    "name": "Egypt",
    "code": "+20",
    "iso": "EG",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/eg.svg",
    "mask": "(000)000-0000",
    "value": "Egypt-(000)000-0000",
    "label": "Egypt (EG)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "Egypt (EG)"
  },
  "El Salvador-00-00-0000": {
    "name": "El Salvador",
    "code": "+503",
    "iso": "SV",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sv.svg",
    "mask": "00-00-0000",
    "value": "El Salvador-00-00-0000",
    "label": "El Salvador (SV)",
    "maskPlaceholder": "00-00-0000",
    "applyMask": "99-99-9999",
    "description": "El Salvador (SV)"
  },
  "Equatorial Guinea-00-000-0000": {
    "name": "Equatorial Guinea",
    "code": "+240",
    "iso": "GQ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gq.svg",
    "mask": "00-000-0000",
    "value": "Equatorial Guinea-00-000-0000",
    "label": "Equatorial Guinea (GQ)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Equatorial Guinea (GQ)"
  },
  "Eritrea-0-000-000": {
    "name": "Eritrea",
    "code": "+291",
    "iso": "ER",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/er.svg",
    "mask": "0-000-000",
    "value": "Eritrea-0-000-000",
    "label": "Eritrea (ER)",
    "maskPlaceholder": "0-000-000",
    "applyMask": "9-999-999",
    "description": "Eritrea (ER)"
  },
  "Estonia-0000-0000": {
    "name": "Estonia",
    "code": "+372",
    "iso": "EE",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ee.svg",
    "mask": "0000-0000",
    "value": "Estonia-0000-0000",
    "label": "Estonia (EE)",
    "maskPlaceholder": "0000-0000",
    "applyMask": "9999-9999",
    "description": "Estonia (EE)"
  },
  "Eswatini-00-00-0000": {
    "name": "Eswatini",
    "code": "+268",
    "iso": "SZ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sz.svg",
    "mask": "00-00-0000",
    "value": "Eswatini-00-00-0000",
    "label": "Eswatini (SZ)",
    "maskPlaceholder": "00-00-0000",
    "applyMask": "99-99-9999",
    "description": "Eswatini (SZ)"
  },
  "Ethiopia-00-000-0000": {
    "name": "Ethiopia",
    "code": "+251",
    "iso": "ET",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/et.svg",
    "mask": "00-000-0000",
    "value": "Ethiopia-00-000-0000",
    "label": "Ethiopia (ET)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Ethiopia (ET)"
  },
  "Falkland Islands (Malvinas)-00000": {
    "name": "Falkland Islands (Malvinas)",
    "code": "+500",
    "iso": "FK",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/fk.svg",
    "mask": "00000",
    "value": "Falkland Islands (Malvinas)-00000",
    "label": "Falkland Islands (Malvinas) (FK)",
    "maskPlaceholder": "00000",
    "applyMask": "99999",
    "description": "Falkland Islands (Malvinas) (FK)"
  },
  "Faroe Islands-000-000": {
    "name": "Faroe Islands",
    "code": "+298",
    "iso": "FO",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/fo.svg",
    "mask": "000-000",
    "value": "Faroe Islands-000-000",
    "label": "Faroe Islands (FO)",
    "maskPlaceholder": "000-000",
    "applyMask": "999-999",
    "description": "Faroe Islands (FO)"
  },
  "Fiji-00-00000": {
    "name": "Fiji",
    "code": "+679",
    "iso": "FJ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/fj.svg",
    "mask": "00-00000",
    "value": "Fiji-00-00000",
    "label": "Fiji (FJ)",
    "maskPlaceholder": "00-00000",
    "applyMask": "99-99999",
    "description": "Fiji (FJ)"
  },
  "Finland-(000)000-00-00": {
    "name": "Finland",
    "code": "+358",
    "iso": "FI",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/fi.svg",
    "mask": "(000)000-00-00",
    "value": "Finland-(000)000-00-00",
    "label": "Finland (FI)",
    "maskPlaceholder": "(000)000-00-00",
    "applyMask": "(999)999-99-99",
    "description": "Finland (FI)"
  },
  "France-(000)000-000": {
    "name": "France",
    "code": "+33",
    "iso": "FR",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/fr.svg",
    "mask": "(000)000-000",
    "value": "France-(000)000-000",
    "label": "France (FR)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "France (FR)"
  },
  "French Guiana-00000-0000": {
    "name": "French Guiana",
    "code": "+594",
    "iso": "GF",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gf.svg",
    "mask": "00000-0000",
    "value": "French Guiana-00000-0000",
    "label": "French Guiana (GF)",
    "maskPlaceholder": "00000-0000",
    "applyMask": "99999-9999",
    "description": "French Guiana (GF)"
  },
  "French Polynesia-00-00-00": {
    "name": "French Polynesia",
    "code": "+689",
    "iso": "PF",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/pf.svg",
    "mask": "00-00-00",
    "value": "French Polynesia-00-00-00",
    "label": "French Polynesia (PF)",
    "maskPlaceholder": "00-00-00",
    "applyMask": "99-99-99",
    "description": "French Polynesia (PF)"
  },
  "Gabon-0-00-00-00": {
    "name": "Gabon",
    "code": "+241",
    "iso": "GA",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ga.svg",
    "mask": "0-00-00-00",
    "value": "Gabon-0-00-00-00",
    "label": "Gabon (GA)",
    "maskPlaceholder": "0-00-00-00",
    "applyMask": "9-99-99-99",
    "description": "Gabon (GA)"
  },
  "Gambia-(000)00-00": {
    "name": "Gambia",
    "code": "+220",
    "iso": "GM",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gm.svg",
    "mask": "(000)00-00",
    "value": "Gambia-(000)00-00",
    "label": "Gambia (GM)",
    "maskPlaceholder": "(000)00-00",
    "applyMask": "(999)99-99",
    "description": "Gambia (GM)"
  },
  "Georgia-(000)000-000": {
    "name": "Georgia",
    "code": "+995",
    "iso": "GE",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ge.svg",
    "mask": "(000)000-000",
    "value": "Georgia-(000)000-000",
    "label": "Georgia (GE)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Georgia (GE)"
  },
  "Germany-(0000)000-0000": {
    "name": "Germany",
    "code": "+49",
    "iso": "DE",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/de.svg",
    "mask": "(0000)000-0000",
    "value": "Germany-(0000)000-0000",
    "label": "Germany (DE)",
    "maskPlaceholder": "(0000)000-0000",
    "applyMask": "(9999)999-9999",
    "description": "Germany (DE)"
  },
  "Ghana-(000)000-000": {
    "name": "Ghana",
    "code": "+233",
    "iso": "GH",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gh.svg",
    "mask": "(000)000-000",
    "value": "Ghana-(000)000-000",
    "label": "Ghana (GH)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Ghana (GH)"
  },
  "Gibraltar-000-00000": {
    "name": "Gibraltar",
    "code": "+350",
    "iso": "GI",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gi.svg",
    "mask": "000-00000",
    "value": "Gibraltar-000-00000",
    "label": "Gibraltar (GI)",
    "maskPlaceholder": "000-00000",
    "applyMask": "999-99999",
    "description": "Gibraltar (GI)"
  },
  "Greece-(000)000-0000": {
    "name": "Greece",
    "code": "+30",
    "iso": "GR",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gr.svg",
    "mask": "(000)000-0000",
    "value": "Greece-(000)000-0000",
    "label": "Greece (GR)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "Greece (GR)"
  },
  "Greenland-00-00-00": {
    "name": "Greenland",
    "code": "+299",
    "iso": "GL",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gl.svg",
    "mask": "00-00-00",
    "value": "Greenland-00-00-00",
    "label": "Greenland (GL)",
    "maskPlaceholder": "00-00-00",
    "applyMask": "99-99-99",
    "description": "Greenland (GL)"
  },
  "Grenada-(473)000-0000": {
    "name": "Grenada",
    "code": "+1",
    "iso": "GD",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gd.svg",
    "mask": "(473)000-0000",
    "value": "Grenada-(473)000-0000",
    "label": "Grenada (GD)",
    "maskPlaceholder": "(473)000-0000",
    "applyMask": "(473)999-9999",
    "description": "Grenada (GD)"
  },
  "Guadeloupe-(000)000-000": {
    "name": "Guadeloupe",
    "code": "+590",
    "iso": "GP",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gp.svg",
    "mask": "(000)000-000",
    "value": "Guadeloupe-(000)000-000",
    "label": "Guadeloupe (GP)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Guadeloupe (GP)"
  },
  "Guam-(671)000-0000": {
    "name": "Guam",
    "code": "+1",
    "iso": "GU",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gu.svg",
    "mask": "(671)000-0000",
    "value": "Guam-(671)000-0000",
    "label": "Guam (GU)",
    "maskPlaceholder": "(671)000-0000",
    "applyMask": "(671)999-9999",
    "description": "Guam (GU)"
  },
  "Guatemala-0-000-0000": {
    "name": "Guatemala",
    "code": "+502",
    "iso": "GT",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gt.svg",
    "mask": "0-000-0000",
    "value": "Guatemala-0-000-0000",
    "label": "Guatemala (GT)",
    "maskPlaceholder": "0-000-0000",
    "applyMask": "9-999-9999",
    "description": "Guatemala (GT)"
  },
  "Guernsey-(0000)000000": {
    "name": "Guernsey",
    "code": "+44",
    "iso": "GG",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gg.svg",
    "mask": "(0000)000000",
    "value": "Guernsey-(0000)000000",
    "label": "Guernsey (GG)",
    "maskPlaceholder": "(0000)000000",
    "applyMask": "(9999)999999",
    "description": "Guernsey (GG)"
  },
  "Guinea-00-000-000": {
    "name": "Guinea",
    "code": "+224",
    "iso": "GN",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gn.svg",
    "mask": "00-000-000",
    "value": "Guinea-00-000-000",
    "label": "Guinea (GN)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Guinea (GN)"
  },
  "Guinea-Bissau-0-000000": {
    "name": "Guinea-Bissau",
    "code": "+245",
    "iso": "GW",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gw.svg",
    "mask": "0-000000",
    "value": "Guinea-Bissau-0-000000",
    "label": "Guinea-Bissau (GW)",
    "maskPlaceholder": "0-000000",
    "applyMask": "9-999999",
    "description": "Guinea-Bissau (GW)"
  },
  "Guyana-000-0000": {
    "name": "Guyana",
    "code": "+592",
    "iso": "GY",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gy.svg",
    "mask": "000-0000",
    "value": "Guyana-000-0000",
    "label": "Guyana (GY)",
    "maskPlaceholder": "000-0000",
    "applyMask": "999-9999",
    "description": "Guyana (GY)"
  },
  "Haiti-00-00-0000": {
    "name": "Haiti",
    "code": "+509",
    "iso": "HT",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ht.svg",
    "mask": "00-00-0000",
    "value": "Haiti-00-00-0000",
    "label": "Haiti (HT)",
    "maskPlaceholder": "00-00-0000",
    "applyMask": "99-99-9999",
    "description": "Haiti (HT)"
  },
  "Holy See (Vatican City State)-06 69800000": {
    "name": "Holy See (Vatican City State)",
    "code": "+39",
    "iso": "VA",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/va.svg",
    "mask": "06 69800000",
    "value": "Holy See (Vatican City State)-06 69800000",
    "label": "Holy See (Vatican City State) (VA)",
    "maskPlaceholder": "06 69800000",
    "applyMask": "96 69899999",
    "description": "Holy See (Vatican City State) (VA)"
  },
  "Honduras-0000-0000": {
    "name": "Honduras",
    "code": "+504",
    "iso": "HN",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/hn.svg",
    "mask": "0000-0000",
    "value": "Honduras-0000-0000",
    "label": "Honduras (HN)",
    "maskPlaceholder": "0000-0000",
    "applyMask": "9999-9999",
    "description": "Honduras (HN)"
  },
  "Hong Kong-0000-0000": {
    "name": "Hong Kong",
    "code": "+852",
    "iso": "HK",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/hk.svg",
    "mask": "0000-0000",
    "value": "Hong Kong-0000-0000",
    "label": "Hong Kong (HK)",
    "maskPlaceholder": "0000-0000",
    "applyMask": "9999-9999",
    "description": "Hong Kong (HK)"
  },
  "Hungary-(000)000-000": {
    "name": "Hungary",
    "code": "+36",
    "iso": "HU",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/hu.svg",
    "mask": "(000)000-000",
    "value": "Hungary-(000)000-000",
    "label": "Hungary (HU)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Hungary (HU)"
  },
  "Iceland-000-0000": {
    "name": "Iceland",
    "code": "+354",
    "iso": "IS",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/is.svg",
    "mask": "000-0000",
    "value": "Iceland-000-0000",
    "label": "Iceland (IS)",
    "maskPlaceholder": "000-0000",
    "applyMask": "999-9999",
    "description": "Iceland (IS)"
  },
  "India-(0000)000-000": {
    "name": "India",
    "code": "+91",
    "iso": "IN",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/in.svg",
    "mask": "(0000)000-000",
    "value": "India-(0000)000-000",
    "label": "India (IN)",
    "maskPlaceholder": "(0000)000-000",
    "applyMask": "(9999)999-999",
    "description": "India (IN)"
  },
  "Indonesia-(800)000-00-000": {
    "name": "Indonesia",
    "code": "+62",
    "iso": "ID",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/id.svg",
    "mask": "(800)000-00-000",
    "value": "Indonesia-(800)000-00-000",
    "label": "Indonesia (ID)",
    "maskPlaceholder": "(800)000-00-000",
    "applyMask": "(899)999-99-999",
    "description": "Indonesia (ID)"
  },
  "Iran-(000)000-0000": {
    "name": "Iran",
    "code": "+98",
    "iso": "IR",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ir.svg",
    "mask": "(000)000-0000",
    "value": "Iran-(000)000-0000",
    "label": "Iran (IR)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "Iran (IR)"
  },
  "Iraq-(000)000-0000": {
    "name": "Iraq",
    "code": "+924",
    "iso": "IQ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/iq.svg",
    "mask": "(000)000-0000",
    "value": "Iraq-(000)000-0000",
    "label": "Iraq (IQ)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "Iraq (IQ)"
  },
  "Ireland-(000)000-000": {
    "name": "Ireland",
    "code": "+353",
    "iso": "IE",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ie.svg",
    "mask": "(000)000-000",
    "value": "Ireland-(000)000-000",
    "label": "Ireland (IE)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Ireland (IE)"
  },
  "Isle of Man-(0000)000000": {
    "name": "Isle of Man",
    "code": "+44",
    "iso": "IM",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/im.svg",
    "mask": "(0000)000000",
    "value": "Isle of Man-(0000)000000",
    "label": "Isle of Man (IM)",
    "maskPlaceholder": "(0000)000000",
    "applyMask": "(9999)999999",
    "description": "Isle of Man (IM)"
  },
  "Israel-50-000-0000": {
    "name": "Israel",
    "code": "+972",
    "iso": "IL",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/il.svg",
    "mask": "50-000-0000",
    "value": "Israel-50-000-0000",
    "label": "Israel (IL)",
    "maskPlaceholder": "50-000-0000",
    "applyMask": "59-999-9999",
    "description": "Israel (IL)"
  },
  "Italy-(000)0000-000": {
    "name": "Italy",
    "code": "+39",
    "iso": "IT",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/it.svg",
    "mask": "(000)0000-000",
    "value": "Italy-(000)0000-000",
    "label": "Italy (IT)",
    "maskPlaceholder": "(000)0000-000",
    "applyMask": "(999)9999-999",
    "description": "Italy (IT)"
  },
  "Ivory Coast / Cote d'Ivoire-00-000-000": {
    "name": "Ivory Coast / Cote d'Ivoire",
    "code": "+225",
    "iso": "CI",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ci.svg",
    "mask": "00-000-000",
    "value": "Ivory Coast / Cote d'Ivoire-00-000-000",
    "label": "Ivory Coast / Cote d'Ivoire (CI)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Ivory Coast / Cote d'Ivoire (CI)"
  },
  "Jamaica-(876)000-0000": {
    "name": "Jamaica",
    "code": "+1",
    "iso": "JM",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/jm.svg",
    "mask": "(876)000-0000",
    "value": "Jamaica-(876)000-0000",
    "label": "Jamaica (JM)",
    "maskPlaceholder": "(876)000-0000",
    "applyMask": "(876)999-9999",
    "description": "Jamaica (JM)"
  },
  "Japan-00-0000-0000": {
    "name": "Japan",
    "code": "+81",
    "iso": "JP",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/jp.svg",
    "mask": "00-0000-0000",
    "value": "Japan-00-0000-0000",
    "label": "Japan (JP)",
    "maskPlaceholder": "00-0000-0000",
    "applyMask": "99-9999-9999",
    "description": "Japan (JP)"
  },
  "Jersey-(0000)0000-000000": {
    "name": "Jersey",
    "code": "+44",
    "iso": "JE",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/je.svg",
    "mask": "(0000)0000-000000",
    "value": "Jersey-(0000)0000-000000",
    "label": "Jersey (JE)",
    "maskPlaceholder": "(0000)0000-000000",
    "applyMask": "(9999)9999-999999",
    "description": "Jersey (JE)"
  },
  "Jordan-0-0000-0000": {
    "name": "Jordan",
    "code": "+962",
    "iso": "JO",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/jo.svg",
    "mask": "0-0000-0000",
    "value": "Jordan-0-0000-0000",
    "label": "Jordan (JO)",
    "maskPlaceholder": "0-0000-0000",
    "applyMask": "9-9999-9999",
    "description": "Jordan (JO)"
  },
  "Kazakhstan-(700)000-00-00": {
    "name": "Kazakhstan",
    "code": "+77",
    "iso": "KZ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/kz.svg",
    "mask": "(700)000-00-00",
    "value": "Kazakhstan-(700)000-00-00",
    "label": "Kazakhstan (KZ)",
    "maskPlaceholder": "(700)000-00-00",
    "applyMask": "(799)999-99-99",
    "description": "Kazakhstan (KZ)"
  },
  "Kenya-000-000000": {
    "name": "Kenya",
    "code": "+254",
    "iso": "KE",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ke.svg",
    "mask": "000-000000",
    "value": "Kenya-000-000000",
    "label": "Kenya (KE)",
    "maskPlaceholder": "000-000000",
    "applyMask": "999-999999",
    "description": "Kenya (KE)"
  },
  "Kiribati-00-000": {
    "name": "Kiribati",
    "code": "+686",
    "iso": "KI",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ki.svg",
    "mask": "00-000",
    "value": "Kiribati-00-000",
    "label": "Kiribati (KI)",
    "maskPlaceholder": "00-000",
    "applyMask": "99-999",
    "description": "Kiribati (KI)"
  },
  "Korea, Democratic People's Republic of Korea-0000-0000000000000": {
    "name": "Korea, Democratic People's Republic of Korea",
    "code": "+850",
    "iso": "KP",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/kp.svg",
    "mask": "0000-0000000000000",
    "value": "Korea, Democratic People's Republic of Korea-0000-0000000000000",
    "label": "Korea, Democratic People's Republic of Korea (KP)",
    "maskPlaceholder": "0000-0000000000000",
    "applyMask": "9999-9999999999999",
    "description": "Korea, Democratic People's Republic of Korea (KP)"
  },
  "Korea, Republic of South Korea-00-000-0000": {
    "name": "Korea, Republic of South Korea",
    "code": "+82",
    "iso": "KR",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/kr.svg",
    "mask": "00-000-0000",
    "value": "Korea, Republic of South Korea-00-000-0000",
    "label": "Korea, Republic of South Korea (KR)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Korea, Republic of South Korea (KR)"
  },
  "Kosovo-000-000-000": {
    "name": "Kosovo",
    "code": "+383",
    "iso": "XK",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/xk.svg",
    "mask": "000-000-000",
    "value": "Kosovo-000-000-000",
    "label": "Kosovo (XK)",
    "maskPlaceholder": "000-000-000",
    "applyMask": "999-999-999",
    "description": "Kosovo (XK)"
  },
  "Kuwait-0000-0000": {
    "name": "Kuwait",
    "code": "+965",
    "iso": "KW",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/kw.svg",
    "mask": "0000-0000",
    "value": "Kuwait-0000-0000",
    "label": "Kuwait (KW)",
    "maskPlaceholder": "0000-0000",
    "applyMask": "9999-9999",
    "description": "Kuwait (KW)"
  },
  "Kyrgyzstan-(000)000-000": {
    "name": "Kyrgyzstan",
    "code": "+996",
    "iso": "KG",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/kg.svg",
    "mask": "(000)000-000",
    "value": "Kyrgyzstan-(000)000-000",
    "label": "Kyrgyzstan (KG)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Kyrgyzstan (KG)"
  },
  "Laos-(2000)000-000": {
    "name": "Laos",
    "code": "+856",
    "iso": "LA",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/la.svg",
    "mask": "(2000)000-000",
    "value": "Laos-(2000)000-000",
    "label": "Laos (LA)",
    "maskPlaceholder": "(2000)000-000",
    "applyMask": "(2999)999-999",
    "description": "Laos (LA)"
  },
  "Latvia-00-000-000": {
    "name": "Latvia",
    "code": "+371",
    "iso": "LV",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/lv.svg",
    "mask": "00-000-000",
    "value": "Latvia-00-000-000",
    "label": "Latvia (LV)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Latvia (LV)"
  },
  "Lebanon-00-000-000": {
    "name": "Lebanon",
    "code": "+961",
    "iso": "LB",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/lb.svg",
    "mask": "00-000-000",
    "value": "Lebanon-00-000-000",
    "label": "Lebanon (LB)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Lebanon (LB)"
  },
  "Lesotho-0-000-0000": {
    "name": "Lesotho",
    "code": "+266",
    "iso": "LS",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ls.svg",
    "mask": "0-000-0000",
    "value": "Lesotho-0-000-0000",
    "label": "Lesotho (LS)",
    "maskPlaceholder": "0-000-0000",
    "applyMask": "9-999-9999",
    "description": "Lesotho (LS)"
  },
  "Liberia-00-000-000": {
    "name": "Liberia",
    "code": "+231",
    "iso": "LR",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/lr.svg",
    "mask": "00-000-000",
    "value": "Liberia-00-000-000",
    "label": "Liberia (LR)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Liberia (LR)"
  },
  "Libya-21-000-0000": {
    "name": "Libya",
    "code": "+218",
    "iso": "LY",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ly.svg",
    "mask": "21-000-0000",
    "value": "Libya-21-000-0000",
    "label": "Libya (LY)",
    "maskPlaceholder": "21-000-0000",
    "applyMask": "21-999-9999",
    "description": "Libya (LY)"
  },
  "Liechtenstein-(000)000-0000": {
    "name": "Liechtenstein",
    "code": "+423",
    "iso": "LI",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/li.svg",
    "mask": "(000)000-0000",
    "value": "Liechtenstein-(000)000-0000",
    "label": "Liechtenstein (LI)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "Liechtenstein (LI)"
  },
  "Lithuania-(000)00-000": {
    "name": "Lithuania",
    "code": "+370",
    "iso": "LT",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/lt.svg",
    "mask": "(000)00-000",
    "value": "Lithuania-(000)00-000",
    "label": "Lithuania (LT)",
    "maskPlaceholder": "(000)00-000",
    "applyMask": "(999)99-999",
    "description": "Lithuania (LT)"
  },
  "Luxembourg-(000)000-000": {
    "name": "Luxembourg",
    "code": "+352",
    "iso": "LU",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/lu.svg",
    "mask": "(000)000-000",
    "value": "Luxembourg-(000)000-000",
    "label": "Luxembourg (LU)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Luxembourg (LU)"
  },
  "Macau-0000-0000": {
    "name": "Macau",
    "code": "+853",
    "iso": "MO",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mo.svg",
    "mask": "0000-0000",
    "value": "Macau-0000-0000",
    "label": "Macau (MO)",
    "maskPlaceholder": "0000-0000",
    "applyMask": "9999-9999",
    "description": "Macau (MO)"
  },
  "Madagascar-00-00-00000": {
    "name": "Madagascar",
    "code": "+261",
    "iso": "MG",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mg.svg",
    "mask": "00-00-00000",
    "value": "Madagascar-00-00-00000",
    "label": "Madagascar (MG)",
    "maskPlaceholder": "00-00-00000",
    "applyMask": "99-99-99999",
    "description": "Madagascar (MG)"
  },
  "Malawi-0-0000-0000": {
    "name": "Malawi",
    "code": "+265",
    "iso": "MW",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mw.svg",
    "mask": "0-0000-0000",
    "value": "Malawi-0-0000-0000",
    "label": "Malawi (MW)",
    "maskPlaceholder": "0-0000-0000",
    "applyMask": "9-9999-9999",
    "description": "Malawi (MW)"
  },
  "Malaysia-00-000-0000": {
    "name": "Malaysia",
    "code": "+60",
    "iso": "MY",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/my.svg",
    "mask": "00-000-0000",
    "value": "Malaysia-00-000-0000",
    "label": "Malaysia (MY)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Malaysia (MY)"
  },
  "Maldives-000-0000": {
    "name": "Maldives",
    "code": "+960",
    "iso": "MV",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mv.svg",
    "mask": "000-0000",
    "value": "Maldives-000-0000",
    "label": "Maldives (MV)",
    "maskPlaceholder": "000-0000",
    "applyMask": "999-9999",
    "description": "Maldives (MV)"
  },
  "Mali-00-00-0000": {
    "name": "Mali",
    "code": "+223",
    "iso": "ML",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ml.svg",
    "mask": "00-00-0000",
    "value": "Mali-00-00-0000",
    "label": "Mali (ML)",
    "maskPlaceholder": "00-00-0000",
    "applyMask": "99-99-9999",
    "description": "Mali (ML)"
  },
  "Malta-0000-0000": {
    "name": "Malta",
    "code": "+356",
    "iso": "MT",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mt.svg",
    "mask": "0000-0000",
    "value": "Malta-0000-0000",
    "label": "Malta (MT)",
    "maskPlaceholder": "0000-0000",
    "applyMask": "9999-9999",
    "description": "Malta (MT)"
  },
  "Marshall Islands-000-0000": {
    "name": "Marshall Islands",
    "code": "+692",
    "iso": "MH",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mh.svg",
    "mask": "000-0000",
    "value": "Marshall Islands-000-0000",
    "label": "Marshall Islands (MH)",
    "maskPlaceholder": "000-0000",
    "applyMask": "999-9999",
    "description": "Marshall Islands (MH)"
  },
  "Martinique-(000)00-00-00": {
    "name": "Martinique",
    "code": "+596",
    "iso": "MQ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mq.svg",
    "mask": "(000)00-00-00",
    "value": "Martinique-(000)00-00-00",
    "label": "Martinique (MQ)",
    "maskPlaceholder": "(000)00-00-00",
    "applyMask": "(999)99-99-99",
    "description": "Martinique (MQ)"
  },
  "Mauritania-00-00-0000": {
    "name": "Mauritania",
    "code": "+222",
    "iso": "MR",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mr.svg",
    "mask": "00-00-0000",
    "value": "Mauritania-00-00-0000",
    "label": "Mauritania (MR)",
    "maskPlaceholder": "00-00-0000",
    "applyMask": "99-99-9999",
    "description": "Mauritania (MR)"
  },
  "Mauritius-000-0000": {
    "name": "Mauritius",
    "code": "+230",
    "iso": "MU",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mu.svg",
    "mask": "000-0000",
    "value": "Mauritius-000-0000",
    "label": "Mauritius (MU)",
    "maskPlaceholder": "000-0000",
    "applyMask": "999-9999",
    "description": "Mauritius (MU)"
  },
  "Mayotte-00000-0000": {
    "name": "Mayotte",
    "code": "+262",
    "iso": "YT",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/yt.svg",
    "mask": "00000-0000",
    "value": "Mayotte-00000-0000",
    "label": "Mayotte (YT)",
    "maskPlaceholder": "00000-0000",
    "applyMask": "99999-9999",
    "description": "Mayotte (YT)"
  },
  "Mexico-(000)000-0000": {
    "name": "Mexico",
    "code": "+52",
    "iso": "MX",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mx.svg",
    "mask": "(000)000-0000",
    "value": "Mexico-(000)000-0000",
    "label": "Mexico (MX)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "Mexico (MX)"
  },
  "Micronesia, Federated States of Micronesia-000-0000": {
    "name": "Micronesia, Federated States of Micronesia",
    "code": "+691",
    "iso": "FM",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/fm.svg",
    "mask": "000-0000",
    "value": "Micronesia, Federated States of Micronesia-000-0000",
    "label": "Micronesia, Federated States of Micronesia (FM)",
    "maskPlaceholder": "000-0000",
    "applyMask": "999-9999",
    "description": "Micronesia, Federated States of Micronesia (FM)"
  },
  "Moldova-0000-0000": {
    "name": "Moldova",
    "code": "+373",
    "iso": "MD",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/md.svg",
    "mask": "0000-0000",
    "value": "Moldova-0000-0000",
    "label": "Moldova (MD)",
    "maskPlaceholder": "0000-0000",
    "applyMask": "9999-9999",
    "description": "Moldova (MD)"
  },
  "Monaco-(000)000-000": {
    "name": "Monaco",
    "code": "+377",
    "iso": "MC",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mc.svg",
    "mask": "(000)000-000",
    "value": "Monaco-(000)000-000",
    "label": "Monaco (MC)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Monaco (MC)"
  },
  "Mongolia-00-00-0000": {
    "name": "Mongolia",
    "code": "+976",
    "iso": "MN",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mn.svg",
    "mask": "00-00-0000",
    "value": "Mongolia-00-00-0000",
    "label": "Mongolia (MN)",
    "maskPlaceholder": "00-00-0000",
    "applyMask": "99-99-9999",
    "description": "Mongolia (MN)"
  },
  "Montenegro-00-000-000": {
    "name": "Montenegro",
    "code": "+382",
    "iso": "ME",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/me.svg",
    "mask": "00-000-000",
    "value": "Montenegro-00-000-000",
    "label": "Montenegro (ME)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Montenegro (ME)"
  },
  "Montserrat-(664)000-0000": {
    "name": "Montserrat",
    "code": "+1",
    "iso": "MS",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ms.svg",
    "mask": "(664)000-0000",
    "value": "Montserrat-(664)000-0000",
    "label": "Montserrat (MS)",
    "maskPlaceholder": "(664)000-0000",
    "applyMask": "(664)999-9999",
    "description": "Montserrat (MS)"
  },
  "Morocco-00-0000-000": {
    "name": "Morocco",
    "code": "+212",
    "iso": "MA",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ma.svg",
    "mask": "00-0000-000",
    "value": "Morocco-00-0000-000",
    "label": "Morocco (MA)",
    "maskPlaceholder": "00-0000-000",
    "applyMask": "99-9999-999",
    "description": "Morocco (MA)"
  },
  "Mozambique-00-000-000": {
    "name": "Mozambique",
    "code": "+258",
    "iso": "MZ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mz.svg",
    "mask": "00-000-000",
    "value": "Mozambique-00-000-000",
    "label": "Mozambique (MZ)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Mozambique (MZ)"
  },
  "Myanmar-00-000-000": {
    "name": "Myanmar",
    "code": "+95",
    "iso": "MM",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mm.svg",
    "mask": "00-000-000",
    "value": "Myanmar-00-000-000",
    "label": "Myanmar (MM)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Myanmar (MM)"
  },
  "Namibia-00-000-0000": {
    "name": "Namibia",
    "code": "+224",
    "iso": "NA",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/na.svg",
    "mask": "00-000-0000",
    "value": "Namibia-00-000-0000",
    "label": "Namibia (NA)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Namibia (NA)"
  },
  "Nauru-000-0000": {
    "name": "Nauru",
    "code": "+674",
    "iso": "NR",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/nr.svg",
    "mask": "000-0000",
    "value": "Nauru-000-0000",
    "label": "Nauru (NR)",
    "maskPlaceholder": "000-0000",
    "applyMask": "999-9999",
    "description": "Nauru (NR)"
  },
  "Nepal-00-000-000": {
    "name": "Nepal",
    "code": "+977",
    "iso": "NP",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/np.svg",
    "mask": "00-000-000",
    "value": "Nepal-00-000-000",
    "label": "Nepal (NP)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Nepal (NP)"
  },
  "Netherlands-00-000-0000": {
    "name": "Netherlands",
    "code": "+31",
    "iso": "NL",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/nl.svg",
    "mask": "00-000-0000",
    "value": "Netherlands-00-000-0000",
    "label": "Netherlands (NL)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Netherlands (NL)"
  },
  "Netherlands Antilles-9000-0000": {
    "name": "Netherlands Antilles",
    "code": "+599",
    "iso": "AN",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/an.svg",
    "mask": "9000-0000",
    "value": "Netherlands Antilles-9000-0000",
    "label": "Netherlands Antilles (AN)",
    "maskPlaceholder": "9000-0000",
    "applyMask": "9999-9999",
    "description": "Netherlands Antilles (AN)"
  },
  "New Caledonia-00-0000": {
    "name": "New Caledonia",
    "code": "+687",
    "iso": "NC",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/nc.svg",
    "mask": "00-0000",
    "value": "New Caledonia-00-0000",
    "label": "New Caledonia (NC)",
    "maskPlaceholder": "00-0000",
    "applyMask": "99-9999",
    "description": "New Caledonia (NC)"
  },
  "New Zealand-(000)000-0000": {
    "name": "New Zealand",
    "code": "+24",
    "iso": "NZ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/nz.svg",
    "mask": "(000)000-0000",
    "value": "New Zealand-(000)000-0000",
    "label": "New Zealand (NZ)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "New Zealand (NZ)"
  },
  "Nicaragua-0000-0000": {
    "name": "Nicaragua",
    "code": "+505",
    "iso": "NI",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ni.svg",
    "mask": "0000-0000",
    "value": "Nicaragua-0000-0000",
    "label": "Nicaragua (NI)",
    "maskPlaceholder": "0000-0000",
    "applyMask": "9999-9999",
    "description": "Nicaragua (NI)"
  },
  "Niger-00-00-0000": {
    "name": "Niger",
    "code": "+227",
    "iso": "NE",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ne.svg",
    "mask": "00-00-0000",
    "value": "Niger-00-00-0000",
    "label": "Niger (NE)",
    "maskPlaceholder": "00-00-0000",
    "applyMask": "99-99-9999",
    "description": "Niger (NE)"
  },
  "Nigeria-(000)000-0000": {
    "name": "Nigeria",
    "code": "+234",
    "iso": "NG",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ng.svg",
    "mask": "(000)000-0000",
    "value": "Nigeria-(000)000-0000",
    "label": "Nigeria (NG)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "Nigeria (NG)"
  },
  "Niue-0000": {
    "name": "Niue",
    "code": "+683",
    "iso": "NU",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/nu.svg",
    "mask": "0000",
    "value": "Niue-0000",
    "label": "Niue (NU)",
    "maskPlaceholder": "0000",
    "applyMask": "9999",
    "description": "Niue (NU)"
  },
  "Norfolk Island-300-000": {
    "name": "Norfolk Island",
    "code": "+672",
    "iso": "NF",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/nf.svg",
    "mask": "300-000",
    "value": "Norfolk Island-300-000",
    "label": "Norfolk Island (NF)",
    "maskPlaceholder": "300-000",
    "applyMask": "399-999",
    "description": "Norfolk Island (NF)"
  },
  "North Macedonia-00-000-000": {
    "name": "North Macedonia",
    "code": "+389",
    "iso": "MK",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mk.svg",
    "mask": "00-000-000",
    "value": "North Macedonia-00-000-000",
    "label": "North Macedonia (MK)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "North Macedonia (MK)"
  },
  "Northern Mariana Islands-(670)000-0000": {
    "name": "Northern Mariana Islands",
    "code": "+1",
    "iso": "MP",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mp.svg",
    "mask": "(670)000-0000",
    "value": "Northern Mariana Islands-(670)000-0000",
    "label": "Northern Mariana Islands (MP)",
    "maskPlaceholder": "(670)000-0000",
    "applyMask": "(679)999-9999",
    "description": "Northern Mariana Islands (MP)"
  },
  "Norway-(000)00-000": {
    "name": "Norway",
    "code": "+47",
    "iso": "NO",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/no.svg",
    "mask": "(000)00-000",
    "value": "Norway-(000)00-000",
    "label": "Norway (NO)",
    "maskPlaceholder": "(000)00-000",
    "applyMask": "(999)99-999",
    "description": "Norway (NO)"
  },
  "Oman-00-000-000": {
    "name": "Oman",
    "code": "+968",
    "iso": "OM",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/om.svg",
    "mask": "00-000-000",
    "value": "Oman-00-000-000",
    "label": "Oman (OM)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Oman (OM)"
  },
  "Pakistan-(000)000-0000": {
    "name": "Pakistan",
    "code": "+92",
    "iso": "PK",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/pk.svg",
    "mask": "(000)000-0000",
    "value": "Pakistan-(000)000-0000",
    "label": "Pakistan (PK)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "Pakistan (PK)"
  },
  "Palau-000-0000": {
    "name": "Palau",
    "code": "+680",
    "iso": "PW",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/pw.svg",
    "mask": "000-0000",
    "value": "Palau-000-0000",
    "label": "Palau (PW)",
    "maskPlaceholder": "000-0000",
    "applyMask": "999-9999",
    "description": "Palau (PW)"
  },
  "Palestine-00-000-0000": {
    "name": "Palestine",
    "code": "+970",
    "iso": "PS",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ps.svg",
    "mask": "00-000-0000",
    "value": "Palestine-00-000-0000",
    "label": "Palestine (PS)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Palestine (PS)"
  },
  "Panama-000-0000": {
    "name": "Panama",
    "code": "+507",
    "iso": "PA",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/pa.svg",
    "mask": "000-0000",
    "value": "Panama-000-0000",
    "label": "Panama (PA)",
    "maskPlaceholder": "000-0000",
    "applyMask": "999-9999",
    "description": "Panama (PA)"
  },
  "Papua New Guinea-(000)00-000": {
    "name": "Papua New Guinea",
    "code": "+675",
    "iso": "PG",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/pg.svg",
    "mask": "(000)00-000",
    "value": "Papua New Guinea-(000)00-000",
    "label": "Papua New Guinea (PG)",
    "maskPlaceholder": "(000)00-000",
    "applyMask": "(999)99-999",
    "description": "Papua New Guinea (PG)"
  },
  "Paraguay-(000)000-000": {
    "name": "Paraguay",
    "code": "+595",
    "iso": "PY",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/py.svg",
    "mask": "(000)000-000",
    "value": "Paraguay-(000)000-000",
    "label": "Paraguay (PY)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Paraguay (PY)"
  },
  "Peru-(000)000-000": {
    "name": "Peru",
    "code": "+51",
    "iso": "PE",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/pe.svg",
    "mask": "(000)000-000",
    "value": "Peru-(000)000-000",
    "label": "Peru (PE)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Peru (PE)"
  },
  "Philippines-(000)000-0000": {
    "name": "Philippines",
    "code": "+63",
    "iso": "PH",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ph.svg",
    "mask": "(000)000-0000",
    "value": "Philippines-(000)000-0000",
    "label": "Philippines (PH)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "Philippines (PH)"
  },
  "Pitcairn-000-000-000": {
    "name": "Pitcairn",
    "code": "+870",
    "iso": "PN",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/pn.svg",
    "mask": "000-000-000",
    "value": "Pitcairn-000-000-000",
    "label": "Pitcairn (PN)",
    "maskPlaceholder": "000-000-000",
    "applyMask": "999-999-999",
    "description": "Pitcairn (PN)"
  },
  "Poland-(000)000-000": {
    "name": "Poland",
    "code": "+48",
    "iso": "PL",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/pl.svg",
    "mask": "(000)000-000",
    "value": "Poland-(000)000-000",
    "label": "Poland (PL)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Poland (PL)"
  },
  "Portugal-00-000-0000": {
    "name": "Portugal",
    "code": "+351",
    "iso": "PT",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/pt.svg",
    "mask": "00-000-0000",
    "value": "Portugal-00-000-0000",
    "label": "Portugal (PT)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Portugal (PT)"
  },
  "Puerto Rico-(939) 000 0000": {
    "name": "Puerto Rico",
    "code": "+1",
    "iso": "PR",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/pr.svg",
    "mask": "(939) 000 0000",
    "value": "Puerto Rico-(939) 000 0000",
    "label": "Puerto Rico (PR)",
    "maskPlaceholder": "(939) 000 0000",
    "applyMask": "(939) 999 9999",
    "description": "Puerto Rico (PR)"
  },
  "Qatar-0000-0000": {
    "name": "Qatar",
    "code": "+974",
    "iso": "QA",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/qa.svg",
    "mask": "0000-0000",
    "value": "Qatar-0000-0000",
    "label": "Qatar (QA)",
    "maskPlaceholder": "0000-0000",
    "applyMask": "9999-9999",
    "description": "Qatar (QA)"
  },
  "Reunion-00000-0000": {
    "name": "Reunion",
    "code": "+262",
    "iso": "RE",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/re.svg",
    "mask": "00000-0000",
    "value": "Reunion-00000-0000",
    "label": "Reunion (RE)",
    "maskPlaceholder": "00000-0000",
    "applyMask": "99999-9999",
    "description": "Reunion (RE)"
  },
  "Romania-00-000-0000": {
    "name": "Romania",
    "code": "+40",
    "iso": "RO",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ro.svg",
    "mask": "00-000-0000",
    "value": "Romania-00-000-0000",
    "label": "Romania (RO)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Romania (RO)"
  },
  "Russia-(000)000-00-00": {
    "name": "Russia",
    "code": "+7",
    "iso": "RU",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ru.svg",
    "mask": "(000)000-00-00",
    "value": "Russia-(000)000-00-00",
    "label": "Russia (RU)",
    "maskPlaceholder": "(000)000-00-00",
    "applyMask": "(999)999-99-99",
    "description": "Russia (RU)"
  },
  "Rwanda-(000)000-000": {
    "name": "Rwanda",
    "code": "+250",
    "iso": "RW",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/rw.svg",
    "mask": "(000)000-000",
    "value": "Rwanda-(000)000-000",
    "label": "Rwanda (RW)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Rwanda (RW)"
  },
  "Saint Barthelemy-000-00-00-00": {
    "name": "Saint Barthelemy",
    "code": "+590",
    "iso": "BL",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/bl.svg",
    "mask": "000-00-00-00",
    "value": "Saint Barthelemy-000-00-00-00",
    "label": "Saint Barthelemy (BL)",
    "maskPlaceholder": "000-00-00-00",
    "applyMask": "999-99-99-99",
    "description": "Saint Barthelemy (BL)"
  },
  "Saint Helena, Ascension and Tristan Da Cunha-0000": {
    "name": "Saint Helena, Ascension and Tristan Da Cunha",
    "code": "+290",
    "iso": "SH",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sh.svg",
    "mask": "0000",
    "value": "Saint Helena, Ascension and Tristan Da Cunha-0000",
    "label": "Saint Helena, Ascension and Tristan Da Cunha (SH)",
    "maskPlaceholder": "0000",
    "applyMask": "9999",
    "description": "Saint Helena, Ascension and Tristan Da Cunha (SH)"
  },
  "Saint Kitts and Nevis-(869)000-0000": {
    "name": "Saint Kitts and Nevis",
    "code": "+1",
    "iso": "KN",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/kn.svg",
    "mask": "(869)000-0000",
    "value": "Saint Kitts and Nevis-(869)000-0000",
    "label": "Saint Kitts and Nevis (KN)",
    "maskPlaceholder": "(869)000-0000",
    "applyMask": "(869)999-9999",
    "description": "Saint Kitts and Nevis (KN)"
  },
  "Saint Lucia-(758)000-0000": {
    "name": "Saint Lucia",
    "code": "+1",
    "iso": "LC",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/lc.svg",
    "mask": "(758)000-0000",
    "value": "Saint Lucia-(758)000-0000",
    "label": "Saint Lucia (LC)",
    "maskPlaceholder": "(758)000-0000",
    "applyMask": "(758)999-9999",
    "description": "Saint Lucia (LC)"
  },
  "Saint Martin-(000)000-000": {
    "name": "Saint Martin",
    "code": "+590",
    "iso": "MF",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/mf.svg",
    "mask": "(000)000-000",
    "value": "Saint Martin-(000)000-000",
    "label": "Saint Martin (MF)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Saint Martin (MF)"
  },
  "Saint Pierre and Miquelon-00-0000": {
    "name": "Saint Pierre and Miquelon",
    "code": "+508",
    "iso": "PM",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/pm.svg",
    "mask": "00-0000",
    "value": "Saint Pierre and Miquelon-00-0000",
    "label": "Saint Pierre and Miquelon (PM)",
    "maskPlaceholder": "00-0000",
    "applyMask": "99-9999",
    "description": "Saint Pierre and Miquelon (PM)"
  },
  "Saint Vincent and the Grenadines-(784)000-0000": {
    "name": "Saint Vincent and the Grenadines",
    "code": "+1",
    "iso": "VC",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/vc.svg",
    "mask": "(784)000-0000",
    "value": "Saint Vincent and the Grenadines-(784)000-0000",
    "label": "Saint Vincent and the Grenadines (VC)",
    "maskPlaceholder": "(784)000-0000",
    "applyMask": "(784)999-9999",
    "description": "Saint Vincent and the Grenadines (VC)"
  },
  "Samoa-00-0000": {
    "name": "Samoa",
    "code": "+685",
    "iso": "WS",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ws.svg",
    "mask": "00-0000",
    "value": "Samoa-00-0000",
    "label": "Samoa (WS)",
    "maskPlaceholder": "00-0000",
    "applyMask": "99-9999",
    "description": "Samoa (WS)"
  },
  "San Marino-0000-000000": {
    "name": "San Marino",
    "code": "+378",
    "iso": "SM",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sm.svg",
    "mask": "0000-000000",
    "value": "San Marino-0000-000000",
    "label": "San Marino (SM)",
    "maskPlaceholder": "0000-000000",
    "applyMask": "9999-999999",
    "description": "San Marino (SM)"
  },
  "Sao Tome and Principe-00-00000": {
    "name": "Sao Tome and Principe",
    "code": "+239",
    "iso": "ST",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/st.svg",
    "mask": "00-00000",
    "value": "Sao Tome and Principe-00-00000",
    "label": "Sao Tome and Principe (ST)",
    "maskPlaceholder": "00-00000",
    "applyMask": "99-99999",
    "description": "Sao Tome and Principe (ST)"
  },
  "Saudi Arabia-50-0000-0000": {
    "name": "Saudi Arabia",
    "code": "+966",
    "iso": "SA",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sa.svg",
    "mask": "50-0000-0000",
    "value": "Saudi Arabia-50-0000-0000",
    "label": "Saudi Arabia (SA)",
    "maskPlaceholder": "50-0000-0000",
    "applyMask": "59-9999-9999",
    "description": "Saudi Arabia (SA)"
  },
  "Senegal-00-000-0000": {
    "name": "Senegal",
    "code": "+221",
    "iso": "SN",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sn.svg",
    "mask": "00-000-0000",
    "value": "Senegal-00-000-0000",
    "label": "Senegal (SN)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Senegal (SN)"
  },
  "Serbia-00-000-0000": {
    "name": "Serbia",
    "code": "+381",
    "iso": "RS",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/rs.svg",
    "mask": "00-000-0000",
    "value": "Serbia-00-000-0000",
    "label": "Serbia (RS)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Serbia (RS)"
  },
  "Seychelles-0-000-000": {
    "name": "Seychelles",
    "code": "+248",
    "iso": "SC",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sc.svg",
    "mask": "0-000-000",
    "value": "Seychelles-0-000-000",
    "label": "Seychelles (SC)",
    "maskPlaceholder": "0-000-000",
    "applyMask": "9-999-999",
    "description": "Seychelles (SC)"
  },
  "Sierra Leone-00-000000": {
    "name": "Sierra Leone",
    "code": "+232",
    "iso": "SL",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sl.svg",
    "mask": "00-000000",
    "value": "Sierra Leone-00-000000",
    "label": "Sierra Leone (SL)",
    "maskPlaceholder": "00-000000",
    "applyMask": "99-999999",
    "description": "Sierra Leone (SL)"
  },
  "Singapore-0000-0000": {
    "name": "Singapore",
    "code": "+65",
    "iso": "SG",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sg.svg",
    "mask": "0000-0000",
    "value": "Singapore-0000-0000",
    "label": "Singapore (SG)",
    "maskPlaceholder": "0000-0000",
    "applyMask": "9999-9999",
    "description": "Singapore (SG)"
  },
  "Sint Maarten-(721)000-0000": {
    "name": "Sint Maarten",
    "code": "+1",
    "iso": "SX",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sx.svg",
    "mask": "(721)000-0000",
    "value": "Sint Maarten-(721)000-0000",
    "label": "Sint Maarten (SX)",
    "maskPlaceholder": "(721)000-0000",
    "applyMask": "(721)999-9999",
    "description": "Sint Maarten (SX)"
  },
  "Slovakia-(000)000-000": {
    "name": "Slovakia",
    "code": "+421",
    "iso": "SK",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sk.svg",
    "mask": "(000)000-000",
    "value": "Slovakia-(000)000-000",
    "label": "Slovakia (SK)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Slovakia (SK)"
  },
  "Slovenia-00-000-000": {
    "name": "Slovenia",
    "code": "+386",
    "iso": "SI",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/si.svg",
    "mask": "00-000-000",
    "value": "Slovenia-00-000-000",
    "label": "Slovenia (SI)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Slovenia (SI)"
  },
  "Solomon Islands-000-0000": {
    "name": "Solomon Islands",
    "code": "+677",
    "iso": "SB",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sb.svg",
    "mask": "000-0000",
    "value": "Solomon Islands-000-0000",
    "label": "Solomon Islands (SB)",
    "maskPlaceholder": "000-0000",
    "applyMask": "999-9999",
    "description": "Solomon Islands (SB)"
  },
  "Somalia-00-000-000": {
    "name": "Somalia",
    "code": "+252",
    "iso": "SO",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/so.svg",
    "mask": "00-000-000",
    "value": "Somalia-00-000-000",
    "label": "Somalia (SO)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Somalia (SO)"
  },
  "South Africa-00-000-0000": {
    "name": "South Africa",
    "code": "+27",
    "iso": "ZA",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/za.svg",
    "mask": "00-000-0000",
    "value": "South Africa-00-000-0000",
    "label": "South Africa (ZA)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "South Africa (ZA)"
  },
  "South Georgia and the South Sandwich Islands-00000": {
    "name": "South Georgia and the South Sandwich Islands",
    "code": "+500",
    "iso": "GS",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gs.svg",
    "mask": "00000",
    "value": "South Georgia and the South Sandwich Islands-00000",
    "label": "South Georgia and the South Sandwich Islands (GS)",
    "maskPlaceholder": "00000",
    "applyMask": "99999",
    "description": "South Georgia and the South Sandwich Islands (GS)"
  },
  "South Sudan-00-000-0000": {
    "name": "South Sudan",
    "code": "+211",
    "iso": "SS",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ss.svg",
    "mask": "00-000-0000",
    "value": "South Sudan-00-000-0000",
    "label": "South Sudan (SS)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "South Sudan (SS)"
  },
  "Spain-(000)000-000": {
    "name": "Spain",
    "code": "+34",
    "iso": "ES",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/es.svg",
    "mask": "(000)000-000",
    "value": "Spain-(000)000-000",
    "label": "Spain (ES)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Spain (ES)"
  },
  "Sri Lanka-00-000-0000": {
    "name": "Sri Lanka",
    "code": "+94",
    "iso": "LK",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/lk.svg",
    "mask": "00-000-0000",
    "value": "Sri Lanka-00-000-0000",
    "label": "Sri Lanka (LK)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Sri Lanka (LK)"
  },
  "Sudan-00-000-0000": {
    "name": "Sudan",
    "code": "+249",
    "iso": "SD",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sd.svg",
    "mask": "00-000-0000",
    "value": "Sudan-00-000-0000",
    "label": "Sudan (SD)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Sudan (SD)"
  },
  "Suriname-000-0000": {
    "name": "Suriname",
    "code": "+597",
    "iso": "SR",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sr.svg",
    "mask": "000-0000",
    "value": "Suriname-000-0000",
    "label": "Suriname (SR)",
    "maskPlaceholder": "000-0000",
    "applyMask": "999-9999",
    "description": "Suriname (SR)"
  },
  "Svalbard and Jan Mayen-(000)00-000": {
    "name": "Svalbard and Jan Mayen",
    "code": "+47",
    "iso": "SJ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sj.svg",
    "mask": "(000)00-000",
    "value": "Svalbard and Jan Mayen-(000)00-000",
    "label": "Svalbard and Jan Mayen (SJ)",
    "maskPlaceholder": "(000)00-000",
    "applyMask": "(999)99-999",
    "description": "Svalbard and Jan Mayen (SJ)"
  },
  "Sweden-00-000-0000": {
    "name": "Sweden",
    "code": "+46",
    "iso": "SE",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/se.svg",
    "mask": "00-000-0000",
    "value": "Sweden-00-000-0000",
    "label": "Sweden (SE)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Sweden (SE)"
  },
  "Switzerland-00-000-0000": {
    "name": "Switzerland",
    "code": "+41",
    "iso": "CH",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ch.svg",
    "mask": "00-000-0000",
    "value": "Switzerland-00-000-0000",
    "label": "Switzerland (CH)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Switzerland (CH)"
  },
  "Syrian Arab Republic-00-0000-000": {
    "name": "Syrian Arab Republic",
    "code": "+963",
    "iso": "SY",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/sy.svg",
    "mask": "00-0000-000",
    "value": "Syrian Arab Republic-00-0000-000",
    "label": "Syrian Arab Republic (SY)",
    "maskPlaceholder": "00-0000-000",
    "applyMask": "99-9999-999",
    "description": "Syrian Arab Republic (SY)"
  },
  "Taiwan-0-0000-0000": {
    "name": "Taiwan",
    "code": "+886",
    "iso": "TW",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/tw.svg",
    "mask": "0-0000-0000",
    "value": "Taiwan-0-0000-0000",
    "label": "Taiwan (TW)",
    "maskPlaceholder": "0-0000-0000",
    "applyMask": "9-9999-9999",
    "description": "Taiwan (TW)"
  },
  "Tajikistan-00-000-0000": {
    "name": "Tajikistan",
    "code": "+992",
    "iso": "TJ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/tj.svg",
    "mask": "00-000-0000",
    "value": "Tajikistan-00-000-0000",
    "label": "Tajikistan (TJ)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Tajikistan (TJ)"
  },
  "Tanzania, United Republic of Tanzania-00-000-0000": {
    "name": "Tanzania, United Republic of Tanzania",
    "code": "+255",
    "iso": "TZ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/tz.svg",
    "mask": "00-000-0000",
    "value": "Tanzania, United Republic of Tanzania-00-000-0000",
    "label": "Tanzania, United Republic of Tanzania (TZ)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Tanzania, United Republic of Tanzania (TZ)"
  },
  "Thailand-00-000-0000": {
    "name": "Thailand",
    "code": "+66",
    "iso": "TH",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/th.svg",
    "mask": "00-000-0000",
    "value": "Thailand-00-000-0000",
    "label": "Thailand (TH)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Thailand (TH)"
  },
  "Timor-Leste-780-00000": {
    "name": "Timor-Leste",
    "code": "+670",
    "iso": "TL",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/tl.svg",
    "mask": "780-00000",
    "value": "Timor-Leste-780-00000",
    "label": "Timor-Leste (TL)",
    "maskPlaceholder": "780-00000",
    "applyMask": "789-99999",
    "description": "Timor-Leste (TL)"
  },
  "Togo-00-000-000": {
    "name": "Togo",
    "code": "+228",
    "iso": "TG",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/tg.svg",
    "mask": "00-000-000",
    "value": "Togo-00-000-000",
    "label": "Togo (TG)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Togo (TG)"
  },
  "Tokelau-0000": {
    "name": "Tokelau",
    "code": "+690",
    "iso": "TK",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/tk.svg",
    "mask": "0000",
    "value": "Tokelau-0000",
    "label": "Tokelau (TK)",
    "maskPlaceholder": "0000",
    "applyMask": "9999",
    "description": "Tokelau (TK)"
  },
  "Tonga-00000": {
    "name": "Tonga",
    "code": "+676",
    "iso": "TO",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/to.svg",
    "mask": "00000",
    "value": "Tonga-00000",
    "label": "Tonga (TO)",
    "maskPlaceholder": "00000",
    "applyMask": "99999",
    "description": "Tonga (TO)"
  },
  "Trinidad and Tobago-(868)000-0000": {
    "name": "Trinidad and Tobago",
    "code": "+1",
    "iso": "TT",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/tt.svg",
    "mask": "(868)000-0000",
    "value": "Trinidad and Tobago-(868)000-0000",
    "label": "Trinidad and Tobago (TT)",
    "maskPlaceholder": "(868)000-0000",
    "applyMask": "(868)999-9999",
    "description": "Trinidad and Tobago (TT)"
  },
  "Tunisia-00-000-000": {
    "name": "Tunisia",
    "code": "+216",
    "iso": "TN",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/tn.svg",
    "mask": "00-000-000",
    "value": "Tunisia-00-000-000",
    "label": "Tunisia (TN)",
    "maskPlaceholder": "00-000-000",
    "applyMask": "99-999-999",
    "description": "Tunisia (TN)"
  },
  "Turkey-(000)000-0000": {
    "name": "Turkey",
    "code": "+90",
    "iso": "TR",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/tr.svg",
    "mask": "(000)000-0000",
    "value": "Turkey-(000)000-0000",
    "label": "Turkey (TR)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "Turkey (TR)"
  },
  "Turkmenistan-0-000-0000": {
    "name": "Turkmenistan",
    "code": "+993",
    "iso": "TM",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/tm.svg",
    "mask": "0-000-0000",
    "value": "Turkmenistan-0-000-0000",
    "label": "Turkmenistan (TM)",
    "maskPlaceholder": "0-000-0000",
    "applyMask": "9-999-9999",
    "description": "Turkmenistan (TM)"
  },
  "Turks and Caicos Islands-(249)000-000": {
    "name": "Turks and Caicos Islands",
    "code": "+1",
    "iso": "TC",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/tc.svg",
    "mask": "(249)000-000",
    "value": "Turks and Caicos Islands-(249)000-000",
    "label": "Turks and Caicos Islands (TC)",
    "maskPlaceholder": "(249)000-000",
    "applyMask": "(249)999-999",
    "description": "Turks and Caicos Islands (TC)"
  },
  "Tuvalu-900000": {
    "name": "Tuvalu",
    "code": "+688",
    "iso": "TV",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/tv.svg",
    "mask": "900000",
    "value": "Tuvalu-900000",
    "label": "Tuvalu (TV)",
    "maskPlaceholder": "900000",
    "applyMask": "999999",
    "description": "Tuvalu (TV)"
  },
  "Uganda-(000)000-000": {
    "name": "Uganda",
    "code": "+256",
    "iso": "UG",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ug.svg",
    "mask": "(000)000-000",
    "value": "Uganda-(000)000-000",
    "label": "Uganda (UG)",
    "maskPlaceholder": "(000)000-000",
    "applyMask": "(999)999-999",
    "description": "Uganda (UG)"
  },
  "Ukraine-(00)000-00-00": {
    "name": "Ukraine",
    "code": "+380",
    "iso": "UA",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ua.svg",
    "mask": "(00)000-00-00",
    "value": "Ukraine-(00)000-00-00",
    "label": "Ukraine (UA)",
    "maskPlaceholder": "(00)000-00-00",
    "applyMask": "(99)999-99-99",
    "description": "Ukraine (UA)"
  },
  "United Arab Emirates-50-000-0000": {
    "name": "United Arab Emirates",
    "code": "+971",
    "iso": "AE",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ae.svg",
    "mask": "50-000-0000",
    "value": "United Arab Emirates-50-000-0000",
    "label": "United Arab Emirates (AE)",
    "maskPlaceholder": "50-000-0000",
    "applyMask": "59-999-9999",
    "description": "United Arab Emirates (AE)"
  },
  "United Kingdom-00-0000-0000": {
    "name": "United Kingdom",
    "code": "+44",
    "iso": "GB",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/gb.svg",
    "mask": "00-0000-0000",
    "value": "United Kingdom-00-0000-0000",
    "label": "United Kingdom (GB)",
    "maskPlaceholder": "00-0000-0000",
    "applyMask": "99-9999-9999",
    "description": "United Kingdom (GB)"
  },
  "United States-(000)000-0000": {
    "name": "United States",
    "code": "+1",
    "iso": "US",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/us.svg",
    "mask": "(000)000-0000",
    "value": "United States-(000)000-0000",
    "label": "United States (US)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "United States (US)"
  },
  "Uruguay-0-000-00-00": {
    "name": "Uruguay",
    "code": "+598",
    "iso": "UY",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/uy.svg",
    "mask": "0-000-00-00",
    "value": "Uruguay-0-000-00-00",
    "label": "Uruguay (UY)",
    "maskPlaceholder": "0-000-00-00",
    "applyMask": "9-999-99-99",
    "description": "Uruguay (UY)"
  },
  "Uzbekistan-00-000-0000": {
    "name": "Uzbekistan",
    "code": "+998",
    "iso": "UZ",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/uz.svg",
    "mask": "00-000-0000",
    "value": "Uzbekistan-00-000-0000",
    "label": "Uzbekistan (UZ)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Uzbekistan (UZ)"
  },
  "Vanuatu-00-00000": {
    "name": "Vanuatu",
    "code": "+678",
    "iso": "VU",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/vu.svg",
    "mask": "00-00000",
    "value": "Vanuatu-00-00000",
    "label": "Vanuatu (VU)",
    "maskPlaceholder": "00-00000",
    "applyMask": "99-99999",
    "description": "Vanuatu (VU)"
  },
  "Venezuela, Bolivarian Republic of Venezuela-(000)000-0000": {
    "name": "Venezuela, Bolivarian Republic of Venezuela",
    "code": "+58",
    "iso": "VE",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ve.svg",
    "mask": "(000)000-0000",
    "value": "Venezuela, Bolivarian Republic of Venezuela-(000)000-0000",
    "label": "Venezuela, Bolivarian Republic of Venezuela (VE)",
    "maskPlaceholder": "(000)000-0000",
    "applyMask": "(999)999-9999",
    "description": "Venezuela, Bolivarian Republic of Venezuela (VE)"
  },
  "Vietnam-(000)0000-000": {
    "name": "Vietnam",
    "code": "+84",
    "iso": "VN",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/vn.svg",
    "mask": "(000)0000-000",
    "value": "Vietnam-(000)0000-000",
    "label": "Vietnam (VN)",
    "maskPlaceholder": "(000)0000-000",
    "applyMask": "(999)9999-999",
    "description": "Vietnam (VN)"
  },
  "Virgin Islands, British-(284)000-0000": {
    "name": "Virgin Islands, British",
    "code": "+1",
    "iso": "VG",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/vg.svg",
    "mask": "(284)000-0000",
    "value": "Virgin Islands, British-(284)000-0000",
    "label": "Virgin Islands, British (VG)",
    "maskPlaceholder": "(284)000-0000",
    "applyMask": "(284)999-9999",
    "description": "Virgin Islands, British (VG)"
  },
  "Virgin Islands, U.S.-(340)000-0000": {
    "name": "Virgin Islands, U.S.",
    "code": "+1",
    "iso": "VI",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/vi.svg",
    "mask": "(340)000-0000",
    "value": "Virgin Islands, U.S.-(340)000-0000",
    "label": "Virgin Islands, U.S. (VI)",
    "maskPlaceholder": "(340)000-0000",
    "applyMask": "(349)999-9999",
    "description": "Virgin Islands, U.S. (VI)"
  },
  "Wallis and Futuna-00-0000": {
    "name": "Wallis and Futuna",
    "code": "+681",
    "iso": "WF",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/wf.svg",
    "mask": "00-0000",
    "value": "Wallis and Futuna-00-0000",
    "label": "Wallis and Futuna (WF)",
    "maskPlaceholder": "00-0000",
    "applyMask": "99-9999",
    "description": "Wallis and Futuna (WF)"
  },
  "Yemen-000-000-000": {
    "name": "Yemen",
    "code": "+967",
    "iso": "YE",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/ye.svg",
    "mask": "000-000-000",
    "value": "Yemen-000-000-000",
    "label": "Yemen (YE)",
    "maskPlaceholder": "000-000-000",
    "applyMask": "999-999-999",
    "description": "Yemen (YE)"
  },
  "Zambia-00-000-0000": {
    "name": "Zambia",
    "code": "+260",
    "iso": "ZM",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/zm.svg",
    "mask": "00-000-0000",
    "value": "Zambia-00-000-0000",
    "label": "Zambia (ZM)",
    "maskPlaceholder": "00-000-0000",
    "applyMask": "99-999-9999",
    "description": "Zambia (ZM)"
  },
  "Zimbabwe-0-000000": {
    "name": "Zimbabwe",
    "code": "+263",
    "iso": "ZW",
    "flag": "https://cdn.kcak11.com/CountryFlags/countries/zw.svg",
    "mask": "0-000000",
    "value": "Zimbabwe-0-000000",
    "label": "Zimbabwe (ZW)",
    "maskPlaceholder": "0-000000",
    "applyMask": "9-999999",
    "description": "Zimbabwe (ZW)"
  }
};